import "./override.scss";
import { de, en, es, fr, it, ja, ko, nl, no, pt, ru, sv, zhHans, zhHant } from "vuetify/src/locale";
import { type UserVuetifyPreset } from "vuetify/types";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { dark, light } from "./theme";

export const preset: Partial<UserVuetifyPreset> = {
  breakpoint: {
    scrollBarWidth: 8,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1264,
      lg: 1904,
    },
  },
  icons: {
    iconfont: "mdiSvg",
    // https://vuetifyjs.com/en/features/icon-fonts/#using-custom-icons
    values: {
      /* Standard Vuetify Icons */
      complete: "capsule-consumer-check-outline-16",
      // cancel: "...",
      close: "capsule-consumer-x-close-outline-24",
      delete: "capsule-consumer-x-outline-16", // delete (e.g. v-chip close)
      // clear: "...",
      // success: "...",
      // info: "...",
      // warning: "...",
      // error: "...",
      checkboxOn: "capsule-consumer-check-outline-16",
      // legacy icon not in design system
      // conflicting icon with same named icon in new system
      checkboxOff: "capsule-checkbox-off",
      // Need Icons from design
      // checkboxIndeterminate: 'capsule-checkbox-indeterminate'
      prev: "capsule-consumer-left-chevron-outline-16",
      next: "capsule-consumer-right-chevron-outline-16",
      // delimiter: "...", // for carousel
      // sort: "...",
      // expand: "...",
      // legacy icon not in design system
      menu: "capsule-menu",
      // subgroup: "...",
      dropdown: "capsule-consumer-down-chevron-outline-16",
      radioOn: "capsule-consumer-check-outline-16",
      // radioOff: "...",
      // edit: "...",
      ratingEmpty: "capsule-brand-star-outline-24",
      ratingFull: "capsule-star-filled",
      ratingHalf: "capsule-star-half",
      // loading: "...",
      // first: "...",
      // last: "...",
      // unfold: "...",
      // file: "...",

      /* Custom Icon Presets */
      add: "capsule-consumer-plus-outline-16",
      linkOut: "capsule-consumer-link-in-new-window-outline-8",
      profile: "capsule-consumer-profile-outline-24",
      // legacy icon not in design system
      // conflicting icon with same named icon in new system
      search: "capsule-consumer-search-outline-16",
    },
  },
  lang: {
    current: "en",
    locales: { de, en, es, fr, it, ja, ko, nl, no, pt, ru, sv, zhHans, zhHant },
    t: undefined,
  },
  rtl: false,
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
    dark: false,
    default: "light",
    disable: false,
    themes: { light, dark },
  },
};
